/// <reference path="../../app.definition.ts" />

import * as angular from "angular";
import * as _ from "lodash";
import { CachedDocument } from "@common/model/cachedDocument";
import { CachedSubject } from "@common/model/cachedSubject";
import { CachedUser } from "@common/model/cachedUser";
import { Discussion } from "@common/model/discussion";
import { Subject, TargetEnum } from "@common/model/subject";
import { User } from "@common/model/user";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { BroadcastService } from "@common/service/broadcast.service";
import { CacheService } from "@common/service/cache.service";
import { PostService } from "@common/service/post.service";
import { FOLDER_MODULES } from "@common/model/constants";
import { PostTypeEnums } from "../model/_adocument";
import { PermissionService } from "ecv/common/permissions";
import { IStateService } from "angular-ui-router";
import { isArray } from "jquery";

export const feedTypeOfDocument = (type = "POST") => {
    switch (type) {
        case FOLDER_MODULES.DOCUMENT:
            return "documents";
        case FOLDER_MODULES.DISCUSSION:
            return "discussions";
        default:
            return "posts";
    }
};
export interface ICachingService {
    fetchDocuments(ids: string[], type?: string, folderType?: string): void;

    getDocuments(
        ids: string[],
        type?: string,
        folderType?: string,
        postType?: string
    ): ng.IPromise<Discussion[]>;
    addOrUpdateDocuments(
        documents: Discussion[]
    ): ng.IPromise<boolean>;
    updateDocumentUserInCache(subjectId, user): ng.IPromise<boolean>;
    deleteDocuments(docId: string): void;
    updateFailStatus(ids): ng.IPromise<boolean>;
    removeFailedDocs(): void;

    getCachedFeeds();
    saveCachedFeeds(feeds: any): void;
    resetCachedFeeds();
    resetCachedFolderFeeds(folderId : number);

    getCachedFolderFeeds();
    getCachedFolderFeedsById(folderId: string);
    saveCachedFolderFeeds(feeds: any): void;
    resetCachedFolderFeeds();
    resetCachedFolderFeedsUsingId(folderId : number);

    addOrUpdateUsers(users: User[]): ng.IPromise<boolean>;
    getCachedUsers(): CachedUser[];
    saveCachedUsers(cachedUsers: CachedUser[]): void;
    getUsers(ids: number[]): ng.IPromise<User[]>;

    getSubjects(ids: number[]): ng.IPromise<Subject[]>;
    getPaginatedDocFeeds(page, size, filter, sort): ng.IPromise<any>;
    getDiscussionObjects(docs): ng.IPromise<Discussion[]>;

    setForFolderReset(field, flag);
    getForFolderReset(field);
}

export class CachingService implements ICachingService {
    private session: Storage;
    USER_STORE_NAME: string = "cachedUsers";
    SUBJECT_STORE_NAME: string = "sortedsubjects";
    FEED_STORE_NAME: string = "cachedFeeds";
    FOLDER_FEED_STORE_NAME: string = "cachedFolderFeeds";

    static $inject = [
        "$q",
        "ApiAdapterService",
        "PostService",
        "CacheService",
        "$state",
        "BroadcastService",
        "PermissionService",
    ];
    constructor(
        private $q: ng.IQService,
        private $_api: JavaApiAdapterService,
        private $_post: PostService,
        private $_cache: CacheService,
        private $state: IStateService,
        private BroadcastService: BroadcastService,
        private PermissionService: PermissionService
    ) {
        this.session = window.sessionStorage;
        !this.getCachedUsers() && this.saveCachedUsers([]);
    }

    // Cache getters and setters

    getCachedUsers = (): CachedUser[] => {
        let retUsers = [];
        let cachedUsers = JSON.parse(
            this.session.getItem(this.USER_STORE_NAME)
        );
        for (let cachedUser of !!cachedUsers ? cachedUsers : []) {
            retUsers.push(CachedUser.from(cachedUser));
        }

        return retUsers;
    };

    saveCachedUsers = (cachedUsers: CachedUser[]): void => {
        try{
           this.session.setItem(
            this.USER_STORE_NAME,
            JSON.stringify(cachedUsers)
        );
        }catch(e)
        {
            console.debug("users not set in cache")
        }

    };

    getCachedSubjects = (): CachedSubject[] => {
        let retSubjects = [];
        let cachedSubjects = JSON.parse(
            this.session.getItem(this.SUBJECT_STORE_NAME)
        );
        for (let cachedSubject of !!cachedSubjects ? cachedSubjects : []) {
            retSubjects.push(CachedSubject.from(cachedSubject));
        }

        return retSubjects;
    };

    getCachedFeeds = () => {
        let emptyFeeds = {
            posts: [],
            documents: [],
            discussions: []
        };
        let cachedFeeds = JSON.parse(
            this.session.getItem(this.FEED_STORE_NAME)
        );
        let retFeeds = !!cachedFeeds ? cachedFeeds : emptyFeeds;
        return retFeeds;
    };

    saveCachedFeeds = (feeds: any): void => {
        try{
            Object.keys(feeds).forEach(k => {
                var docsToCache: CachedDocument[] = [];
                for(let d of !!feeds[k] ? feeds[k] : []){
                    let cacheDoc = CachedDocument.from(d);
                    docsToCache.push(cacheDoc);
                }
                feeds[k] = docsToCache;
            })
            this.session.setItem(
             this.FEED_STORE_NAME,
             JSON.stringify(feeds)
         );
         }catch(e)
         {
             console.debug("feeds not set in cache")
         }
    }

    resetCachedFeeds = () => {
        this.session[this.FEED_STORE_NAME] = JSON.stringify({
            posts: [],
            documents: [],
            discussions: []
        });
    };


    setForFolderReset = (field, flag) => {
        try{let cachedFeed = this.getCachedFolderFeeds();
        cachedFeed[field] = flag;
        this.session.setItem(
            this.FOLDER_FEED_STORE_NAME,
            JSON.stringify(cachedFeed)
        );}catch(e)
        {
            console.log("folder reset not set in cache.")
        }

    };

    getForFolderReset = (field) => {
        let cachedFeed = JSON.parse(
            this.session.getItem(this.FOLDER_FEED_STORE_NAME)
        );
        return !!cachedFeed && !cachedFeed[field];
    };

    getCachedFolderFeeds = () => {
        let cachedFolderFeeds = JSON.parse(
            this.session.getItem(this.FOLDER_FEED_STORE_NAME)
        );
        return !!cachedFolderFeeds ? cachedFolderFeeds : {};
    };

    getCachedFolderFeedsById = (folderId: string) => {
        let cachedFolderFeeds = JSON.parse(
            this.session.getItem(this.FOLDER_FEED_STORE_NAME)
        );
        if (!!cachedFolderFeeds && !!cachedFolderFeeds[folderId]) {
            return cachedFolderFeeds[folderId];
        }
        return [];
    };

    saveCachedFolderFeeds = (feeds: any): void => {
        try {
            Object.keys(feeds).forEach(k => {
                var docsToCache: CachedDocument[] = [];
                if(isArray(feeds[k])){
                    for (let d of feeds[k]) {
                        let cacheDoc = CachedDocument.from(d);
                        docsToCache.push(cacheDoc);
                    }
                    feeds[k] = docsToCache;
                }
            })
            this.session.setItem(
                this.FOLDER_FEED_STORE_NAME,
                JSON.stringify(feeds)
            );
        } catch (e) {
            console.debug("folderFeeds not set in cache")
        }
    }

    resetCachedFolderFeeds = () => {
        this.session[this.FOLDER_FEED_STORE_NAME] = JSON.stringify({});
    };

    //reset the case of the folder.
    resetCachedFolderFeedsUsingId = (folderId: number) => {
        var cachedFolderDetails = JSON.parse(this.session[this.FOLDER_FEED_STORE_NAME]);
        if (cachedFolderDetails.hasOwnProperty(folderId)) {
            // Reset the value of the key
            cachedFolderDetails[folderId] = [];
            // Store the updated object back into sessionStorage
            this.session[this.FOLDER_FEED_STORE_NAME] = JSON.stringify(cachedFolderDetails);
        }
    };

    // add items to cache or update existing
    addOrUpdateUsers = (users: User[]): ng.IPromise<boolean> => {
        try {
            const cachedUsers = this.getCachedUsers();

            for (const user of users) {
                let cachedUser = cachedUsers.find((u) => u.id == user.id);
                if (!!cachedUser) {
                    cachedUser.update(user);
                } else {
                    cachedUser = CachedUser.from(user);
                    cachedUsers.push(cachedUser);
                }
            }

            this.saveCachedUsers(cachedUsers);
            return this.$q.when(true);
        } catch (e) {
            console.error("Failed to add or update users in cache", e);
            return this.$q.reject(e);
        }
    };

    addOrUpdateDocuments = (
        documents: Discussion[]
    ): ng.IPromise<boolean> => {
        try {
            const cachedDocuments = this.getCachedFeeds();
            const notViewedCnt = this.$_cache.getNotViewedCount();
            let notViewedCntUpdated = false;

            const updateDocumentsInFeeds = (doc, cachedDocs, type) => {
                const cachedDocument = cachedDocs[type].find(
                    (d) => d.id == doc.id
                );

                if (cachedDocument) {
                    // When a doc/disc is reshared, there are chances that the originally shared doc
                    // may or may not have been viewed yet and it is now reshared again.
                    // So update the notViewedCount only if, the original doc/disc was viewed before
                    // and now it has been reshared again.
                    if (cachedDocument.viewed === true && doc.viewed === false) {
                        notViewedCnt[doc.postType]++;
                        notViewedCntUpdated = true;
                    }

                    const ind = cachedDocs[type].findIndex(
                        (d) => d.id == doc.id
                    );
                    cachedDocument.documentUsers = doc.documentUsers;
                    cachedDocument.documentFolderId = doc.documentFolderId;
                    cachedDocs[type].splice(ind, 1, cachedDocument);
                }
            };

            for (const doc of documents) {
                updateDocumentsInFeeds(
                    doc,
                    cachedDocuments,
                    feedTypeOfDocument(doc.documentType)
                );
                updateDocumentsInFeeds(doc, cachedDocuments, "posts");
            }
            this.saveCachedFeeds(cachedDocuments);

            if (notViewedCntUpdated) {
                this.$_cache.setNotViewedCount(notViewedCnt);
                this.BroadcastService.broadcast("viewed-count-updated");
            }

            return this.$q.when(true);
        } catch (e) {
            console.error("Failed to add or update documents in cache", e);
            return this.$q.reject(e);
        }
    };

    updateDocumentUserInCache = (subjectId, user): ng.IPromise<boolean> => {
        try {
            const cachedDocuments = this.getCachedFeeds();
            const promises: ng.IPromise<any>[] = [];

            const findAndUpdateDocumentsInFeeds = (type, subjectId, user) => {
                const filteredPosts = cachedDocuments[type].filter(
                    (p) => p.subjectId == subjectId && !!p.documentUsers
                );

                if (filteredPosts && filteredPosts.length > 0) {
                    // This returns a promise, which we'll add to our list.
                    return this.$_post.updatePostUserFormerStatus(filteredPosts, user);
                }
                // Return a resolved promise if there's nothing to do.
                return this.$q.when();
            };

            promises.push(findAndUpdateDocumentsInFeeds("posts", subjectId, user));
            promises.push(findAndUpdateDocumentsInFeeds("documents", subjectId, user));
            promises.push(findAndUpdateDocumentsInFeeds("discussions", subjectId, user));

            // Wait for all the updates to complete.
            return this.$q.all(promises).then(() => {
                // Only save the cache after all updates are done.
                this.saveCachedFeeds(cachedDocuments);
                return true;
            });
        } catch (e) {
            console.error("Failed to update document user in cache", e);
            return this.$q.reject(e);
        }
    };

    deleteDocuments = (docId: string): void => {
        var feeds = this.getCachedFeeds();
        var cachedDocuments = feeds["posts"];
        for (var i = 0; i < cachedDocuments.length; i++) {
            if (cachedDocuments[i].id == docId) {
                cachedDocuments.splice(i, 1);
                break;
            }
        }
        this.saveCachedFeeds(feeds);
    };

    updateFailStatus = (ids: any[]): ng.IPromise<boolean> => {
        var deferred = this.$q.defer<boolean>();
        var feeds = this.getCachedFeeds();
        if (!feeds || !feeds["posts"]) {
            deferred.resolve(false); // Resolve with false if cache is empty
            return deferred.promise;
        }
        var cachedDocuments = feeds["posts"];
        for (var i = 0; i < ids.length; i++) {
            var cachedDoc = cachedDocuments.find((d) => d.id == ids[i].id);
            if (!!cachedDoc) {
                cachedDoc["failed"] = true;
                cachedDoc["uploading"] = true;
            }
        }
        this.saveCachedFeeds(feeds);
        deferred.resolve(true); // Resolve with true on success
        return deferred.promise;
    };

    removeFailedDocs = (): void => {
        var feeds = this.getCachedFeeds();
        feeds["posts"] = feeds["posts"].filter((d) => !d.failed);
        this.saveCachedFeeds(feeds);
    };

    // retrieve items from the backend

    fetchDocuments = (
        ids: string[],
        type: string,
        folderType?: string,
        postType?: string
    ): ng.IPromise<any> => {
        var deferred: ng.IDeferred<CachedDocument[]> =
            this.$q.defer();
        let password = this.$_cache.getPassword();
        if (!ids || ids.length == 0) {
            deferred.resolve([]);
            return deferred.promise;
        }
        var docsToCache: Discussion[] = [];
        var docsToReturn: CachedDocument[] = [];
        var usersToCache: User[] = [];

        var isCommentsRequired =
            this.$state.current.name == "parent-carefeed" ? true : false;

        let filter = {
            documentTypes: type ? [type] : ["DISCUSSION", "DOCUMENT"],
            addComments: isCommentsRequired,
        };
        if(!!postType && postType == PostTypeEnums.LINK){
            filter["linkIds"] = ids;
        } else {
            filter["documentIds"] = ids;
        }
        if (folderType) {
            filter["folderType"] = folderType;
        }
        if (!!password) {
            this.$_api
                .getPostsV2(password, 0, 10, filter, null)
                .then((s) => {

                    for (let doc of !!s.posts ? s.posts : []) {
                        !!doc.documentUsers &&
                            doc.documentUsers.length > 0 &&
                            (usersToCache = usersToCache.concat(
                                doc.documentUsers
                            ));
                        let docToCache = CachedDocument.from(doc);
                        docsToReturn.push(docToCache);
                        // console.log(docToCache);
                        docsToCache.push(doc);
                    }
                    this.addOrUpdateUsers(usersToCache)
                        .then(
                            (s1) => {
                                deferred.resolve(docsToReturn);
                            },
                            (err1) => {
                                // TODO Fill out error logic
                            }
                        )
                        .catch((err) => {
                            console.error("error", err);
                            // TODO Fill out error logic
                        });
                })
                .catch((e) => {
                    console.error("error", e);
                });
        } else {
            deferred.reject();
        }
        return deferred.promise;
    };

    fetchUsers = (ids: number[]): ng.IPromise<CachedUser[]> => {
        var deferred: ng.IDeferred<CachedUser[]> = this.$q.defer();

        if (!ids || ids.length == 0) {
            deferred.resolve([]);
            return deferred.promise;
        }

        var cachedUsers: CachedUser[] = this.getCachedUsers();

        this.$_api.getUsersById(ids).then(
            (s) => {
                let retUsers: CachedUser[] = [];
                for (let user of !!s.users ? s.users : []) {
                    retUsers.push(CachedUser.from(user));
                }
                cachedUsers = cachedUsers.concat(retUsers);
                this.saveCachedUsers(cachedUsers);
                deferred.resolve(retUsers);
            },
            (err) => {
                // TODO Fill out error logic
            }
        );

        return deferred.promise;
    };

    fetchSubjects = (ids: number[]): ng.IPromise<Subject[]> => {
        var deferred: ng.IDeferred<Subject[]> = this.$q.defer();

        if (!ids || ids.length == 0) {
            deferred.resolve([]);
            return deferred.promise;
        }

        this.$_api.getSubjectsById(ids).then(
            (s) => {
                deferred.resolve(s);
            },
            (err) => {
                // TODO Fill out error logic
            }
        );

        return deferred.promise;
    };

    getDocuments = (
        ids: string[],
        type: string = "",
        folderType?,
        postType?:string
    ): ng.IPromise<Discussion[]> => {
        let deferred: ng.IDeferred<Discussion[]> = this.$q.defer();
        let currentUser = this.$_cache.getUser();

        if (!ids || ids.length == 0) {
            deferred.resolve([]);
            return deferred.promise;
        }

        let retCachedDocs: CachedDocument[] = [];
        let nonCachedIds: string[] = [];

        let cacheDocs = this.getCachedFeeds()[type];
        cacheDocs = !!cacheDocs ? cacheDocs : [];

        // Get CachedDocument from cache or add id to list for retrieval
        for (let id of ids) {
            let cacheDoc = cacheDocs.find((findDoc) => findDoc.id == id);
            // console.log("CS<Document> -> Checking cache for", id, ": Found...", !!cacheDoc ? "Yes; is valid..." + (cacheDoc.isValidByTime() ? 'Yes' : 'No') : "No");
            // console.log("cD:", cacheDoc);
            if (!!cacheDoc) {
                //&& cacheDoc.isValidByTime()
                retCachedDocs.push(cacheDoc);
            } else {
                nonCachedIds.push(id);
            }
        }
        // console.log("CS<Document> -> List of ids to get from server:", nonCachedIds);

        // Get docs from backend
        this.fetchDocuments(nonCachedIds, type, folderType,postType).then(
            (newCachedDocs) => {
                for (let newCacheDoc of newCachedDocs) {
                    retCachedDocs.push(newCacheDoc);
                }

                this.getDiscussionObjects(retCachedDocs).then((retDocs) => {
                    deferred.resolve(retDocs);
                    //console.log("CS<Document> -> Retrieved Documents:", retDocs);
                });
            },
            (error) => {
                // TODO Fill out error logic
            }
        );

        return deferred.promise;
    };

    getDiscussionObjects = (docs): ng.IPromise<Discussion[]> => {
        let deferred: ng.IDeferred<Discussion[]> = this.$q.defer();
        let currentUser = this.$_cache.getUser();
        let retDocs: Discussion[] = [];
        let promises = [];
        let subjIds = _.map(docs, "subjectId");
        let subjArr;
        let docPerms = {};
        let userPerms;
        let docUsers;
        promises.push(
            this.PermissionService.getPermissionsForTarget(
                TargetEnum.RESOURCE_LIBRARY_DOCUMENT,
                [currentUser.partyId]
            ).then((permissions) => {
                userPerms = permissions[0][TargetEnum.RESOURCE_LIBRARY_DOCUMENT];
                return;
            })
        );
        _.remove(subjIds, (id) => id == undefined);
        if (subjIds && subjIds.length > 0) {
            promises.push(
                this.getSubjects(_.uniq(subjIds)).then(
                    (subjects: Subject[]) => {
                        subjArr = subjects;
                        let partyIds = _.map(subjects, "teamPartyId");
                        if (partyIds.length) {
                            return this.PermissionService.fetchPermissionsForTarget(
                                partyIds
                            ).then((perm) => {
                                docPerms = perm;
                                return;
                            });
                        } else {
                            return;
                        }
                    }
                )
            );
        }

        let userIds = [];
        docs.forEach((d) => {
            if(d.allUserIds && d.allUserIds.length > 0){
                userIds = [...userIds, ...d.allUserIds];
            } else {
                let documentUserIds = _.map(d.documentUsers, 'id');
                userIds = [...userIds, ...documentUserIds];
                !!d.documentViewerIds && (userIds = [...userIds, ...d.documentViewerIds]);
                userIds.push(d.ownerId);
                if (!!d.comments && d.comments.length > 0) {
                    let commentSenderIds = _.map(d.comments, 'senderId');
                    userIds = [...userIds, ...commentSenderIds];
                };
            }
        });
        promises.push(
            this.getUsers(_.uniq(userIds)).then((users) => {
                docUsers = users;
                return;
            })
        );

        this.$q.all(promises).then(() => {
            docs.forEach((rd) => {
                let newDoc = new Discussion().deserialize(rd);
                newDoc.owner = docUsers.find(u => u.id == rd.ownerId);
                let documentUserIds = _.map(rd.documentUsers, 'id');
                newDoc.documentUsers = _.cloneDeep(docUsers.filter(u => _.includes(documentUserIds, u.id)));
                newDoc.documentUsers.forEach(du => {
                    let permType = rd.documentUsers.find((findUser) => findUser.id == du.id);
                    du.permissionType = permType.permissionType;
                    du.isFormerTeamMember = permType.isFormerTeamMember;
                    du.isActive = permType.isActive;
                    du.permissionEndDate = permType.permissionEndDate;
                    du.isDocDeleted = permType.isDocDeleted;
                });
                !!rd.documentViewerIds && (newDoc.documentViewers = docUsers.filter(u => _.includes(rd.documentViewerIds, u.id)));
                newDoc._ownerFullName();
                //In the carefeed list, we get the latest comment. In that only the senderId is available and not the other
                // details of the sender. But for the discussion page, the fetch comments api returns the sender details.
                // So we need to set up sender only for the first comment, for the carefeed list api.
                if (!!newDoc.comments && newDoc.comments.length > 0 && newDoc.comments[0].senderId) {
                    newDoc.comments[0].sender = docUsers.find(u => u.id == newDoc.comments[0].senderId);
                }
                if (newDoc.ownerId == currentUser.userId) {
                    newDoc.permissionType = "OWN";
                }

                if (newDoc.subjectId) {
                    newDoc.subject = subjArr.find(
                        (s) => s.subjectId == newDoc.subjectId
                    );
                    newDoc._subjectFullName();
                    newDoc.userPerm =
                        docPerms[newDoc.subject.teamPartyId][
                            TargetEnum.DOCUMENT
                        ];
                } else {
                    newDoc.userPerm = userPerms;
                }

                retDocs.push(newDoc);
            });
            deferred.resolve(retDocs);
        });

        return deferred.promise;
    };

    getPaginatedDocFeeds = (
        page,
        size,
        filter = null,
        sort = null
    ): ng.IPromise<any> => {
        let deferred = this.$q.defer();
        let password = this.$_cache.getPassword();
        this.$_api.getPostsV2(password, page, size, filter, sort).then(data => {
            deferred.resolve(data);
        })
        return deferred.promise;
    };
    getUsers = (
        ids: number[]
    ): ng.IPromise<User[]> => {
        var deferred: ng.IDeferred<User[]> = this.$q.defer();

        if (!ids || ids.length == 0) {
            deferred.resolve([]);
            return deferred.promise;
        }

        var retUsers: User[] = [];
        let retCachedUsers: CachedUser[] = [];
        let nonCachedIds: number[] = [];

        let cacheUsers = this.getCachedUsers();
        // Get CachedDocument from cache or add id to list for retrieval
        for (let id of ids) {
            let cacheUser = cacheUsers.find(
                (findUser) => findUser.id == id
            );
            // console.log("CS<User> -> Checking cache for", id, ": Found...", !!cacheUser ? "Yes; is valid..." + (cacheUser.isValidByTime() ? 'Yes' : 'No') : "No");

            if (!!cacheUser) {
                //&& cacheUser.isValidByTime()
                cacheUser.access();
                retCachedUsers.push(cacheUser);
            } else {
                nonCachedIds.push(id);
            }
        }

        //console.log("CS<User> -> List of ids to get from server:", nonCachedIds);
        // Get docs from backend
        this.fetchUsers(nonCachedIds).then(
            (newCachedUsers) => {
                for (let newCacheUser of newCachedUsers) {
                    retCachedUsers.push(newCacheUser);
                }

                for (let retUser of retCachedUsers) {
                    retUsers.push(new User().deserialize(retUser));
                }

                //console.log("CS<User> -> Retrieved Users:", retUsers);
                deferred.resolve(retUsers);
            },
            (error) => {
                // TODO Fill out error logic
            }
        );

        return deferred.promise;
    };

    getSubjects = (ids: number[]): ng.IPromise<Subject[]> => {
        var deferred: ng.IDeferred<Subject[]> = this.$q.defer();

        if (!ids || ids.length == 0) {
            deferred.resolve([]);
            return deferred.promise;
        }

        var retSubjects: Subject[] = [];
        let retCachedSubjects: CachedSubject[] = [];
        let nonCachedIds: number[] = [];

        let cacheSubjects = this.getCachedSubjects();
        let subs = this.$_cache.getSubjects();

        // Convert Subject[] to CachedSubject[] before concatenating
        const subsAsCached = subs.map(s => CachedSubject.from(s));
        let allSub = cacheSubjects.concat(subsAsCached);

        for (let id of ids) {
            let cacheSubject = allSub.find(
                (findSubject) => findSubject.subjectId == id
            );

            // console.log("CS<Subject> -> Checking cache for", id, ": Found...", !!cacheSubject ? "Yes; is valid..." + (cacheSubject.isValidByTime() ? 'Yes' : 'No') : "No");

            if (!!cacheSubject) {
                // && cacheSubject.isValidByTime()
                retCachedSubjects.push(cacheSubject);
            } else {
                nonCachedIds.push(id);
            }
        }

        // console.log("CS<Subject> -> List of ids to get from server:", nonCachedIds);

        // Get docs from backend
        this.fetchSubjects(nonCachedIds).then(
            (newCachedSubjects) => {
                subs = subs.concat(newCachedSubjects);
                this.$_cache.setSubjects(subs);
                for (let newCacheSubject of newCachedSubjects) {
                    let cachedSubject = CachedSubject.from(newCacheSubject);
                    retCachedSubjects.push(cachedSubject);
                }

                for (let retSubject of retCachedSubjects) {
                    retSubjects.push(
                        new Subject().deserialize(retSubject)
                    );
                }

                // console.log("CS<Subject> -> Retrieved Subjects:", retSubjects);
                deferred.resolve(retSubjects);
            },
            (error) => {
                // TODO Fill out error logic
            }
        );

        return deferred.promise;
    };
}

angular.module("eCareVault.common.services")
.service("CachingService", CachingService);
